import { getPaginator } from "../services/ranking";

export default function useRanking() {
  return {
    getPaginator,
  };
}
